import { createAsyncThunk } from "@reduxjs/toolkit";
import { closeSnackbar, enqueueSnackbar, SnackbarKey } from "notistack";

import { getDashboardsHierarchyThunk } from "./getDashboardsHierarchyThunk";
import { cloudChiprApi } from "../../../../services/cloudchipr.api";

export const createDashboardHierarchyFolderThunkFixedCacheKey =
  "createDashboardHierarchyFolderThunk-fixedCacheKey";

export const createDashboardHierarchyFolderThunk = createAsyncThunk(
  "dashboard/createDashboardHierarchyFolder",
  async (name: string, { dispatch }) => {
    const { postUsersMeOrganisationsCurrentDashboardFolders } =
      cloudChiprApi.endpoints;

    try {
      const response = await dispatch(
        postUsersMeOrganisationsCurrentDashboardFolders.initiate(
          {
            body: {
              name: name,
            },
          },
          {
            fixedCacheKey: createDashboardHierarchyFolderThunkFixedCacheKey,
          },
        ),
      ).unwrap();

      if (response) {
        dispatch(getDashboardsHierarchyThunk());
        const snackbarId: SnackbarKey = enqueueSnackbar(
          "Folder successfully created.",
          {
            variant: "snackbarAlert",
            AlertSnackBarProps: {
              severity: "success",
              onClose: () => closeSnackbar(snackbarId),
            },
          },
        );
      }
    } catch (e) {
      // @ts-expect-error TODO: return to this after adding error type
      const errMessage = e?.data?.message || "Something went wrong";
      const snackbarId: SnackbarKey = enqueueSnackbar(errMessage, {
        variant: "snackbarAlert",
        AlertSnackBarProps: {
          severity: "error",
          onClose: () => closeSnackbar(snackbarId),
        },
      });
    }
  },
);
